import { createIcon } from '../createIcon';
import { ReactComponent as IconClock } from '../svg/clock.svg';

export default createIcon(IconClock);
